import { gql } from "generated-graphql";

export const WASTE_MANIFEST_VENDORS_TABLE_QUERY = gql(/* GraphQL */ `
  query WasteManifestVendorsTable(
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [SortModel!]
  ) {
    wasteManifestVendorsTable(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        id
        name
        createdAt
        createdBy
        updatedAt
        updatedBy
        orgCount
        orgNames
        manifestCount
      }
      count
    }
  }
`);

export const WASTE_MANIFEST_VENDOR_NAMES_QUERY = gql(/* GraphQL */ `
  query WasteManifestVendorNames {
    wasteManifestVendors
  }
`);

export const CREATE_WASTE_MANIFEST_VENDOR = gql(/* GraphQL */ `
  mutation CreateWasteManifestVendor($input: CreateWasteManifestVendorInput!) {
    createWasteManifestVendor(input: $input) {
      id
      name
      createdAt
      createdBy
      updatedAt
      updatedBy
      orgCount
      manifestCount
    }
  }
`);

export const DELETE_WASTE_MANIFEST_VENDOR = gql(/* GraphQL */ `
  mutation DeleteWasteManifestVendor($id: ID!) {
    deleteWasteManifestVendor(id: $id)
  }
`);
